import { Flex } from '@components/Flex';
import { styled } from '@styledComponents';
import { Button } from '@components/Button';
import { Text } from '@components/typography';
import { TOP_BANNER_HEIGHT } from 'src/layout/Layout.constants';
import { themeColor, themeSpace, themeMediaQuery, themeVariant } from '@utils/styledTheme.util';

export const DesktopWrapper = styled(Flex)`
  ${themeMediaQuery('below_sm')} {
    display: none;
  }
`;

/** Wrapper for Find an Event button - hidden below md (1152px) to make room for promo text */
export const FindEventWrapper = styled(Flex)`
  display: none;
  ${themeMediaQuery('md')} {
    display: flex;
  }
`;

export const StyledBannerContainer = styled(Flex)<{ variant: 'blue' | 'default' }>`
  width: 100%;
  align-items: center;
  justify-content: space-between;
  height: ${TOP_BANNER_HEIGHT}px;
  position: relative;
  top: 0;
  padding: 0px ${themeSpace(2)};

  animation: topbar;
  animation-delay: 0.6s;
  animation-duration: 4s;
  animation-timing-function: ease-out;
  animation-fill-mode: forwards;
  background: ${({ theme, variant }) => (variant === 'blue' ? '#4951ef' : themeColor('black', 0.8)({ theme }))};
  backdrop-filter: blur(8px) saturate(180%);

  ${themeMediaQuery('sm')} {
    padding: 0px ${themeSpace(7)};
  }

  ${themeMediaQuery('md')} {
    padding: 0px ${themeSpace(10)};
  }
`;

export const StyledNavButton = styled(Button)<{ active: boolean }>`
  ${themeVariant('menuNav14')};
  height: 28px;
  display: flex;
  align-items: center;
  border-radius: 14px;
  padding: 0 ${themeSpace(3)};
  text-underline-offset: 3px;
  background: ${({ active }) => (active ? 'rgba(255, 255, 255, 0.15)' : 'transparent')};
  &:hover {
    background: rgba(255, 255, 255, 0.15);
  }
  &:active {
    background: rgba(255, 255, 255, 0.25);
    color: ${themeColor('white')};
  }

  ${themeMediaQuery('md')} {
    padding: 0 ${themeSpace(4)};
  }
`;

export const StyledFlex = styled(Flex)`
  position: relative;
  column-gap: ${themeSpace(1)};
`;

export const StyledNewFlag = styled(Flex)`
  column-gap: ${themeSpace(1)};
`;

export const StyledText = styled(Text)`
  font-size: 10px;
  line-height: 11px;
  font-weight: 600;
  padding: ${themeSpace(1)} ${themeSpace(2)};
  background-color: ${themeColor('white')};
  border-radius: ${themeSpace(7)};
  color: #4951ef; /* Match top bar background so text looks like knockout */
`;

/** Flex container for nav button content with icon + text, matches LanguageMenu spacing */
export const StyledNavButtonContent = styled(Flex)`
  align-items: center;
  gap: ${themeSpace(1)}; /* 4px - same as globe icon spacing */
`;

/** Wrapper for search icon with scale transform */
export const StyledSearchIcon = styled(Flex)`
  transform: scale(0.917);
`;
